import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

/**
 *  ADATKEZELÉSI SZABÁLYZAT / TÁJÉKOZTATÓ – nyilvános, bejelentkezés NÉLKÜL elérhető oldal (/adatkezeles).
 *
 *  Az intézmény adatkezelési szabályzatát a tanulmányi rendszeren át is hozzáférhetővé kell tenni
 *  (jogszabályfigyelő: tr-adatkezelesi-szabalyzat, Nkt. 43. § (1)). A dokumentumot az intézmény tölti fel
 *  (Admin › Rendszer › Adatkezelési szabályzat, backend/adatkezelesi-tajekoztato.js); ez az oldal az
 *  akadálymentesítési nyilatkozat mintájára őr nélküli útvonal, a belépő oldalról, a családi belépés
 *  képernyőjéről és a menü aljáról linkelve. `?intezmeny=` szűkít egy intézményre.
 */
interface Dok {
  id: string; tipus: string; tipus_nev: string; cim: string; fajlnev: string | null;
  meret: number | null; hatalyos_tol: string | null; feltoltve: string | null; url: string;
}
interface Intezmeny { intezmeny: string; nev: string; om: string; dokumentumok: Dok[]; }

@Component({
  selector: 'app-adatkezeles',
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule],
  templateUrl: './adatkezeles.component.html',
  styleUrls: ['./adatkezeles.component.scss'],
})
export class AdatkezelesComponent implements OnInit {
  intezmenyek: Intezmeny[] = [];
  fut = true;
  hiba = '';

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  async ngOnInit() {
    const szuro = String(this.route.snapshot.queryParamMap.get('intezmeny') || '').trim();
    try {
      //  Token nélkül: a végpont nyilvános, a belépett felhasználó jegye se menjen ki feleslegesen.
      const r = await firstValueFrom(this.http.get<{ intezmenyek: Intezmeny[] }>('/api/adatkezeles/public',
        { headers: new HttpHeaders({ 'Skip-Auth': '1' }), params: szuro ? { intezmeny: szuro } : {} }));
      this.intezmenyek = Array.isArray(r?.intezmenyek) ? r.intezmenyek : [];
    } catch (e: any) {
      this.hiba = 'A dokumentumok most nem érhetők el. Próbáld újra később.';
    } finally {
      this.fut = false;
    }
  }

  /** A PDF címe: weben relatív, a mobilappban a kiszolgáló teljes címével (mint az api-prefix.interceptor). */
  href(d: Dok): string {
    if (!Capacitor.isNativePlatform()) return d.url;
    return `${String(environment.apiOrigin || '').replace(/\/api\/?$/, '')}${d.url}`;
  }

  /** 'YYYY-MM-DD' → 'YYYY. MM. DD.' */
  datum(d: string | null | undefined): string {
    return /^\d{4}-\d{2}-\d{2}$/.test(String(d || '')) ? `${d!.slice(0, 4)}. ${d!.slice(5, 7)}. ${d!.slice(8, 10)}.` : '';
  }

  meret(b: number | null): string {
    if (!b) return '';
    return b >= 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(b / 1024))} kB`;
  }
}
